<template>
  <div class="loading_dialog" :style="{top: scrollTop + 'px', left: scrollLeft + 'px'}">
    <div v-if="type === 'options'" class="loading_dialog_box">
      <p class="loading_dialog_top">提示</p>
      <img src="../../assets/img/pic_loading.gif" height="130" width="200"/>
      <span>操作正在进行中，请勿关闭浏览器或离开页面........</span>
    </div>

    <div v-if="type === 'NOP'" class="loading_NOP">
      <span>正在加载中......</span>
    </div>

    <div v-if="type === 'permissions'" class="loading_NOP">
      <span>您没有访问操作此功能的权限，请联系管理员！</span>
    </div>

    <div v-if="type === 'loginTimeout'" class="loading_NOP">
      <p>登录超时，请点击<a @click="logBackIn()" title="重新登录">这里</a>重新登录</p>
    </div>
  </div>
</template>

<script type="es6">
  export default {
    name: 'loading-dialog',
    props: ['type', 'scrollTop', 'scrollLeft'],
    /**
     *  type加载显示页面类型:  options=有操作后的显示页面  NOP=空操作，用于加载  loginTimeout=加载超时
     * */
    methods: {
      // 重新登录
      logBackIn() {
        this.$router.push({
          path: '/login'
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/css/base-color";

  .loading_dialog {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 990;

    .loading_dialog_box {
      overflow: hidden;
      margin-top: -20px;
      margin-bottom: -20px;
      background-color: $cfff;

      .loading_dialog_top {
        height: 50px;
        line-height: 50px;
        background-color: #f7f7f8;
        border-bottom: 1px solid #eeeeee;
        padding: 0 6%;
      }

      img {
        float: left;
        margin-left: -25px;
      }

      span {
        display: inline-block;
        height: 130px;
        line-height: 130px;
        float: left;
        margin-left: -50px;
        margin-right: 50px;
      }
    }

    .loading_NOP {
      span, p {
        font-size: 18px;
        color: $cfff;
      }

      p {
        a {
          color: rgba(45, 109, 204, 1);

          &:hover {
            cursor: pointer;
            color: #2D8CF0;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public-component/loading-dialog.vue